<template>
	<el-cascader :placeholder="placeholder" :options="shengshiqu" @change="Change" separator=" " filterable></el-cascader>
</template>

<script>
	import dizhiku from '../plugins/dizhiku.js'
	export default {
		data() {
			return {
				shengshiqu: [],
				
			}
		},
		props: {
			value: {
				type: String,
				default: ""
			},
			liandong:{
				type:[String,Number],
				default: 3
			}
		},
		mounted() {
			this.CSH()
		},
		computed:{
			placeholder(){
				return this.value;
			}
		},
		methods: {
			CSH() {
				var l = 0;
				for (var i in dizhiku.sheng) {
					this.shengshiqu.push({
						value: i,
						label: dizhiku.sheng[i],
						children: this.Shi(i)
					});
				}

			},
			Shi(qishi) {
				if(this.liandong<2){
					return '';
				}
				var lie = [];
				var l = 0;
				var ll = 0;
				qishi = Number(qishi);
				for (var i in dizhiku.shi) {
					qishi += 100;
					l++;
					if (dizhiku.shi[qishi]) {
						lie[ll++] = {
							value: qishi,
							label: dizhiku.shi[qishi],
							children: this.Qu(qishi)
						};
					} else if (l >= 100) {
						break;
					}
				}
				return lie;
			},
			Qu(qishi) {
				if(this.liandong<3){
					return '';
				}
				var lie = [];
				var l = 0;
				var ll = 0;
				qishi = Number(qishi);
				for (var i in dizhiku.qu) {
					qishi += 1;
					l++;
					if (dizhiku.qu[qishi]) {
						lie[ll++] = {
							value: qishi,
							label: dizhiku.qu[qishi]
						};
					} else if (l >= 100) {
						break;
					}
				}
				return lie;
			},
			Change(e) {
				var shengshiqu = dizhiku.sheng[e[0]] 
				if(this.liandong>1){
					shengshiqu+= ' ' + dizhiku.shi[e[1]]
				}
				if(this.liandong>2){
					shengshiqu+= ' ' +dizhiku.qu[e[2]]
				}				
				this.$emit('input', shengshiqu)
			},

		}
	}
</script>

<style>


</style>
